import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { formatDate } from "../../../../utils/misc";

import {
  Button,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  Grid,
  Autocomplete
} from "@mui/material";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import { useTheme } from "@mui/material/styles";

import { WORKFLOW_MODES } from "../../../../constants";

import { addressParse } from "@zerodep/address-parse";

export default function KioskEditDialog({
  subscription,
  open,
  handleClose,
  handleSaveEditChanges,
  newlocationOptions,
  newlocationList,
  locationsLoading
}) {
  const theme = useTheme();

  const [subscriptions, setSubscriptions] = useState(subscription);

  const [active, setActive] = useState(true);
  const [locationName, setLocationName] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [locationCode, setLocationCode] = useState("");
  const [subscriptionID, setSubscriptionID] = useState("");
  const [defaultWorkflow, setDefaultWorkflow] = useState("");
  const [enableWebClient, setEnableWebClient] = useState(false);

  const [addressParseObj, setAddressParseObj] = useState("");

  useEffect(() => {
    setSubscriptions(subscription);

    if (subscription) {
      setLocationName(subscription.locationName);
      setLocationAddress(subscription.locationAddress);
      setLocationCode(subscription.locationCode);
      setSubscriptionID(subscription.subscriptionID);
      setDefaultWorkflow(subscription.defaultWorkflowMode);
      setActive(subscription.active);
      setEnableWebClient(subscription.enableWebClient);
      setAddressParseObj(addressParse(subscription.locationAddress));
    }
  }, [subscription]);

  const [locationOptions, setLocationOptions] = useState([]);
  const [locationList, setLocationList] = useState([]);

  useEffect(() => {
    if (locationCode !== null && subscription !== null) {
      setLocationList([...newlocationList, subscription.locationCode]);
    }
  }, [newlocationList, subscription]);

  const changeLocationCombo = async (evt, newlocation) => {
    setLocationCode(newlocation);

    //Find info from locationOptions
    //let locationOption = locationOptions.find(l => {
    //  return l.code == newlocation;
    //});
    //console.log("changeLocationCombo locationOption", locationOption);
    //setLocationobject(locationOption);
  };

  const saveChanges = async () => {
    const payload = {
      _id: subscription._id,
      locationName: locationName,
      locationAddress: locationAddress,
      locationCode: locationCode,
      subscriptionID: subscriptionID,
      defaultWorkflowMode: defaultWorkflow,
      active: active,
      enableWebClient: enableWebClient
    };

    await handleSaveEditChanges(payload);
    //handleClose(); //Moved to handleSaveEditChanges
  };

  const revertChanges = async () => {
    if (subscription) {
      setLocationName(subscription.locationName);
      setLocationAddress(subscription.locationAddress);
      setLocationCode(subscription.locationCode);
      setSubscriptionID(subscription.subscriptionID);
      setActive(subscription.active);
      setEnableWebClient(subscription.enableWebClient);
      setAddressParseObj(addressParse(subscription.locationAddress));
    }

    handleClose();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={false}
        maxWidth={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-kiosklist"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "30vw"
          }}
        >
          <DialogTitle
            id="modal-kiosklist"
            style={{
              maxWidth: "19vw"
            }}
          >
            Edit {subscriptions ? subscriptions.locationName : ""} [
            {subscriptions ? subscriptions.locationCode : ""}]
          </DialogTitle>
          <FormControlLabel
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginRight: theme.spacing(3)
            }}
            control={
              <Switch
                checked={active}
                color="success"
                onChange={event => {
                  setActive(event.target.checked);
                }}
              />
            }
            label={active ? "Active" : "Disabled"}
          />
        </div>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <Grid container width="30vw" spacing={2}>
            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="Location Name"
                value={locationName}
                onChange={event => {
                  let newText = event.target.value;
                  setLocationName(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                disablePortal
                id="cblocationoptions"
                options={locationList ? locationList : []}
                onChange={changeLocationCombo}
                value={locationCode}
                getOptionLabel={option => {
                  return option ? option || option.toString() : "";
                }}
                isOptionEqualToValue={(option, value) => {
                  return option && value
                    ? option.id === value.id
                    : option === value;
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    name="name"
                    label="Location Code"
                    value={locationCode}
                    style={{ marginBottom: theme.spacing(2) }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="standard-basic"
                label="Location Address"
                value={locationAddress}
                onChange={event => {
                  let newText = event.target.value;
                  setLocationAddress(newText);
                  let parsed = addressParse(newText);
                  setAddressParseObj(parsed);
                }}
                variant="outlined"
                fullWidth
              />

              <div style={{ color: "grey" }}>
                <div style={{ margin: "6px 14px" }}>
                  <span style={{ fontStyle: "italic" }}>City:</span>{" "}
                  {addressParseObj && <span>{addressParseObj.city}</span>}
                </div>
                <div style={{ margin: "6px 14px" }}>
                  <span style={{ fontStyle: "italic" }}>State/Prov:</span>{" "}
                  {addressParseObj && <span>{addressParseObj.stateAbbr}</span>}
                </div>
              </div>
            </Grid>

            <Grid item xs={6}>
              <TextField
                id="standard-basic"
                label="Authenication Key"
                value={subscriptionID}
                onChange={event => {
                  let newText = event.target.value;
                  setSubscriptionID(newText);
                }}
                variant="outlined"
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="default-workflow-select-label">
                  New Kiosk Workflow
                </InputLabel>
                <Select
                  labelId="default-workflow-open-select-label"
                  id="default-workflow-open-select"
                  label="Workflow Mode"
                  value={defaultWorkflow}
                  onChange={async event => {
                    setDefaultWorkflow(event.target.value);
                  }}
                >
                  <MenuItem value={WORKFLOW_MODES.BAGS_AND_LABELS}>
                    Bag and Labels
                  </MenuItem>
                  <MenuItem value={WORKFLOW_MODES.BAG_ONLY}>Bags Only</MenuItem>
                  <MenuItem value={WORKFLOW_MODES.BAG_ONLY_WITH_AUTH}>
                    Bags Only With Authenication
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                style={{
                  // width: "100%",
                  display: "flex",
                  //justifyContent: "flex-end",
                  marginRight: theme.spacing(3)
                }}
                control={
                  <Switch
                    checked={enableWebClient}
                    color="success"
                    onChange={event => {
                      setEnableWebClient(event.target.checked);
                    }}
                  />
                }
                label={
                  enableWebClient ? "WebClient Enabled" : "WebClient Disabled"
                }
              />
              {enableWebClient == false &&
                subscription &&
                subscription.enableWebClient == true && (
                  <div style={{ color: "red" }}>
                    Disabling web clients will return idle connected web clients
                    to the configuration screen.
                  </div>
                )}
              {/* <FormControl fullWidth>
                <InputLabel id="default-workflow-select-label">
                enableWebClient
                </InputLabel>
                <Select
                  labelId="default-workflow-open-select-label"
                  id="default-workflow-open-select"
                  label="Workflow Mode"
                  value={defaultWorkflow}
                  onChange={async event => {
                    setDefaultWorkflow(event.target.value);
                  }}
                >
                  <MenuItem value={WORKFLOW_MODES.BAGS_AND_LABELS}>
                    Bag and Labels
                  </MenuItem>
                  <MenuItem value={WORKFLOW_MODES.BAG_ONLY}>Bags Only</MenuItem>
                  <MenuItem value={WORKFLOW_MODES.BAG_ONLY_WITH_AUTH}>
                    Bags Only With Authenication
                  </MenuItem>
                </Select>
              </FormControl> */}
            </Grid>
          </Grid>
          {/* </Box> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={revertChanges}>Cancel</Button>
          <Button onClick={saveChanges} color="secondary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
